import { Vue, Component, Prop } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { ResearchModel } from '@/models/research/research';

@Component({
    name: 'research-pull-out',
    components: {
        'material-icon': GoogleMaterialIcon,
    },
})

export default class ResearchPullOut extends Vue {

    // ----------------------------------------------------------------------
    // Properties
    @Prop()
    private selectedProject!: ResearchModel;

    // ------------------------------------------------------------------
    // Hooks

    // -------------------------------------------------------------------------
    // Actions

    /**
     * Action triggered when clicked on back button
     */
    private goBack() {
        (this.$refs.researchPullout as any).style.left = '110%';
    }



}
